import { useCallback, useState } from "react";
import { ImportantDateEventEnum } from "../../../models/ImportantDate/ImportantDateEventEnum";
import { SchoolYear } from "../../../models";


type UseSchoolYearEditableParams = {
  schoolYears?: SchoolYear[];
};

type UseSchoolYearEditableResult = {
  isSchoolYearEditable: boolean;
  evaluateSchoolYearEditable: (yearId?: number | null) => void;
};

export const useSchoolYearEditable = ({
  schoolYears,
}: UseSchoolYearEditableParams): UseSchoolYearEditableResult => {
  const [isSchoolYearEditable, setIsSchoolYearEditable] = useState(false);

  const evaluateSchoolYearEditable = useCallback(
    (yearId?: number | null) => {
      if (!yearId || !schoolYears?.length) {
        setIsSchoolYearEditable(false);

        return;
      }

      const year = schoolYears.find((schoolYear) => schoolYear.id === yearId);

      if (!year || !year.isCurrent) {
        setIsSchoolYearEditable(false);

        return;
      }

      const eventId = ImportantDateEventEnum.DeliveryOfInitialLists as number;
      const importantDate = year.importantDates.find(
        (importantDate) => importantDate.eventId === eventId
      );

      if (!importantDate) {
        setIsSchoolYearEditable(false);

        return;
      }

      const exactlyNow = new Date(Date.now());
      const dateFrom = new Date(importantDate.dateTimeFrom);
      const dateTo = new Date(importantDate.dateTimeTo);

      if (dateFrom <= exactlyNow && dateTo >= exactlyNow) {
        setIsSchoolYearEditable(true);

        return;
      }

      setIsSchoolYearEditable(false);
    },
    [schoolYears]
  );

  return {
    isSchoolYearEditable,
    evaluateSchoolYearEditable,
  };
};

